module.exports = __webpack_public_path__ + "img/DOCSIGN.70bb36ed.jpg";